import React, { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  Divider,
  DialogContent,
  Grid,
  DialogActions,
  Typography,
  MenuItem,
  TextField,
} from "@material-ui/core";
import { UserDataContext } from "../../Contexts/UserDataContext";
import { ParcelDataContext } from "../../Contexts/ParcelDataContext";
import ButtonApprove from "../ButtonApprove";
import ButtonDownload from "../ButtonDownload";
import { getCurrentBranchesArray } from "../../GlobalFunctions";
const axios = require("axios");

const ApproveDpc = (props) => {
  const { truckId, itemData, week, day, itemId, ...otherProps } = props;
  const { userData } = useContext(UserDataContext);
  const { createParcelModel } = useContext(ParcelDataContext);
  const parcelDataModel = createParcelModel({ week });
  const currentBranchArray = getCurrentBranchesArray(userData.branches, week);
  const branchesObject = currentBranchArray.reduce((acc, cur) => {
    acc[cur.shortCode] = cur;
    return acc;
  }, {});
  const [loading, setLoading] = useState(false);
  const [originalData, setOriginalData] = useState({});

  const faf = (() => {
    if (itemData.mode === "P") {
      return branchesObject[itemData.puBranch].faf;
    } else if (itemData.mode === "D") {
      return branchesObject[itemData.delBranch].faf;
    }
  })();

  const displayColumns = [
    "eventTimeString",
    "cNote",
    "senderName",
    "sendSuburb",
    "receiverName",
    "receiverSuburb",
    "puBranch",
    "delBranch",
    "kg",
    "m3",
    "mode",
    "dpc",
    "reason",
    "driverComments",
    "adminComments",
  ];

  const reasons = ["Missing from DPCs", "Other"];

  useEffect(() => {
    if (Object.keys(originalData).length === 0 && !itemData.userAdded) {
      const fetchOriginalData = async () => {
        const req = {
          method: "GET",
          url: `parcels/getOriginalDPC/${itemId}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `bearer ${userData.token}`,
          },
        };
        try {
          setLoading(true);
          const res = await axios(req);
          setOriginalData(res.data);
        } catch (error) {
          console.log(error);
        } finally {
          setLoading(false);
        }
      };
      fetchOriginalData();
    }
  }, []);

  return (
    <Dialog {...otherProps} fullWidth maxWidth="md">
      <DialogTitle>Approval Screen</DialogTitle>
      <Divider />
      <DialogContent>
        <Grid
          container
          direction="column"
          justify="flex-start"
          alignItems="stretch"
          spacing={1}
        >
          {itemData.userAdded &&
            displayColumns.map((col) => {
              console.log(col);
              return (
                <Grid item key={col}>
                  <Grid container>
                    <Grid item xs={3}>
                      <Typography>
                        {parcelDataModel[col].displayName}:
                      </Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <TextField
                        fullWidth
                        value={itemData[col]}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        {...parcelDataModel[col].textFieldProps}
                        {...(col === "reason" && {
                          children: reasons.map((e) => (
                            <MenuItem key={e} value={e}>
                              {e}
                            </MenuItem>
                          )),
                        })}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              );
            })}

          {!itemData.userAdded && (
            <Grid item>
              <Grid container spacing={1}>
                <Grid item xs={4}>
                  <Typography>Column:</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography>Original:</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography>New:</Typography>
                </Grid>
              </Grid>
            </Grid>
          )}

          {!itemData.userAdded &&
            displayColumns.map((col) => (
              <Grid item key={col}>
                <Grid container spacing={1}>
                  <Grid item xs={4}>
                    <Typography>{parcelDataModel[col].displayName}:</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      value={originalData[col]}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                      {...parcelDataModel[col].textFieldProps}
                      {...(col === "reason" && {
                        children: reasons.map((e) => (
                          <MenuItem key={e} value={e}>
                            {e}
                          </MenuItem>
                        )),
                      })}
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      value={itemData[col]}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                      {...parcelDataModel[col].textFieldProps}
                      {...(col === "reason" && {
                        children: reasons.map((e) => (
                          <MenuItem key={e} value={e}>
                            {e}
                          </MenuItem>
                        )),
                      })}
                    />
                  </Grid>
                </Grid>
              </Grid>
            ))}

          <Grid item>
            <Grid container>
              <Grid item xs={3}>
                <Typography>Fuel Adjustment Factor:</Typography>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  fullWidth
                  value={Math.round(Number(itemData.dpc) * faf * 100) / 100} // hard coded
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <Divider />
      <DialogActions>
        <ButtonDownload variant="contained" color="primary" itemId={itemId} />
        <ButtonApprove
          callback={props.onClose}
          variant="contained"
          color="primary"
          controller="parcels"
          truckId={truckId}
          week={week}
          day={day}
          itemId={itemId}
          itemData={itemData}
          disabled={loading}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ApproveDpc;
